import React, { useCallback } from "react";
import { Dropdown, Menu, Icon, Button, message } from "antd";
import copy from "copy-to-clipboard";
import { withTranslation } from "react-i18next";

import * as gtag from "../../lib/gtag";

// Cada canal agrega ?...&source=<canal> al link público de la vacante; ese source
// se persiste como origen cuando el candidato aplica/da like
// (api-core candidate/likes/like.js -> metadata.sourceName).
const ICONS = {
  whatsapp: "message",
  copy: "link",
  x: "twitter",
  facebook: "facebook",
  email: "mail"
};

const buildUrl = (id, source) =>
  `${process.env.REACT_APP_APPLY_URL}?id=${id}&source=${source}`;

const openWindow = url => window.open(url, "_blank", "noopener,noreferrer");

const shareTo = (channel, url, text) => {
  const e = encodeURIComponent;
  switch (channel) {
    case "whatsapp":
      openWindow(`https://wa.me/?text=${e(`${text} ${url}`)}`);
      break;
    case "x":
      openWindow(
        `https://twitter.com/intent/tweet?url=${e(url)}&text=${e(text)}`
      );
      break;
    case "facebook":
      openWindow(`https://www.facebook.com/sharer/sharer.php?u=${e(url)}`);
      break;
    case "email":
      window.location.href = `mailto:?subject=${e(text)}&body=${e(url)}`;
      break;
    default:
      break;
  }
};

const ShareButton = ({ opportunity, t, size }) => {
  const onSelect = useCallback(
    ({ key }) => {
      const url = buildUrl(opportunity.id, key);
      const text = opportunity.title || t("opportunity:details.title");
      if (key === "copy") {
        copy(url);
        message.success(t("components:OpportunityCard.copiedOpportunityId"));
      } else {
        shareTo(key, url, text);
      }
      gtag.event({
        category: "VacancyDetail",
        action: `VacancyDetail.Share.${key}`,
        label: opportunity.id
      });
    },
    [opportunity.id, opportunity.title, t]
  );

  const overlay = (
    <Menu onClick={onSelect} data-test="share-opportunity-menu">
      <Menu.Item key="whatsapp">
        <Icon type={ICONS.whatsapp} /> WhatsApp
      </Menu.Item>
      <Menu.Item key="copy">
        <Icon type={ICONS.copy} /> {t("opportunity:details.copyLink")}
      </Menu.Item>
      <Menu.Item key="x">
        <Icon type={ICONS.x} /> X
      </Menu.Item>
      <Menu.Item key="facebook">
        <Icon type={ICONS.facebook} /> Facebook
      </Menu.Item>
      <Menu.Item key="email">
        <Icon type={ICONS.email} /> E-mail
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={overlay} trigger={["click"]}>
      <Button size={size} data-test="share-opportunity">
        {t("opportunity:details.share")}
        <Icon type="share-alt" />
      </Button>
    </Dropdown>
  );
};

export default withTranslation(["opportunity", "components"])(ShareButton);
